module.exports = __webpack_public_path__ + "static/img/clock.493bae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/clock.png
// module id = hepQ
// module chunks = 2